/**
 * Implementuje třídá podporující dešifrování dat po blocích
 */
export interface IStreamDecryptor {
    /**
     * Dešifruje data po blocích.
     * @param data Blok dat, který se má dešifrovat. Hodnota nesmí být prázdný blok data jinak funkce vyhodí vyjímku.
     * @param lastBlock Určuje jestli v datech je poslední block, která se bude dešifrovat.
     */
    decryptBlock(data: BufferSource, lastBlock?: boolean): Promise<ArrayBuffer>;
}
